export function PlayIcon() {
    return (

        <div className="position-absolute">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="76"
                height="76"
                fill="none"
                viewBox="0 0 76 76"
            >
                <g filter="url(#filter0_d_5459_12513)" opacity="0.3">
                    <circle cx="37" cy="36" r="24" fill="#101010"></circle>
                </g>
                <path
                    fill="#fff"
                    d="M30 26.782v18.436c0 1.406 1.544 2.26 2.732 1.495l14.443-9.218c1.1-.694 1.1-2.296 0-3.008l-14.443-9.2c-1.188-.765-2.732.09-2.732 1.495z"
                ></path>
                <defs>
                    <filter
                        id="filter0_d_5459_12513"
                        width="76"
                        height="76"
                        x="0"
                        y="0"
                        colorInterpolationFilters="sRGB"
                        filterUnits="userSpaceOnUse"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix
                            in="SourceAlpha"
                            result="hardAlpha"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        ></feColorMatrix>
                        <feOffset dx="1" dy="2"></feOffset>
                        <feGaussianBlur stdDeviation="7"></feGaussianBlur>
                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                        <feBlend
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_5459_12513"
                        ></feBlend>
                        <feBlend
                            in="SourceGraphic"
                            in2="effect1_dropShadow_5459_12513"
                            result="shape"
                        ></feBlend>
                    </filter>
                </defs>
            </svg>
        </div>

    );
}